import { Box, styled } from "@material-ui/core"
import { navigate } from '@reach/router'
import React, { useEffect, useState, useLayoutEffect, useRef } from 'react'
import { TemplateProps } from "../../journeys/journey/Interfaces"
import { Typography } from "@material-ui/core";
import SelectedListItem from "../../molecules/SelectedList/SelectedListItem";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import './Home.css'
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import axios from "axios";
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from "../../context";
import actionTypeConstants from "../../utils/actionTypeConstants";
import CustomizedRatings from "../../atoms/AmsRating/AmsRating";
import AmsLoading from "../../atoms/AmsLoading/AmsLoading";
import { getAdditionalStops, createAddress, createAdditionalAddr, getMobileOperatingSystem, clearSessionData } from "../../utils/helpers";

const customerDetailsApiEndPoint = process.env["REACT_APP_CUSTOMER_DETAIL_END_POINT"]

const api_key = process.env["REACT_APP_API_KEY"];

const initialObj = {
    text: "",
    index: 0
}



const Home: React.FC<TemplateProps> = (props: any) => {

    const { templateProps } = props
    const { title, list, btnProps } = templateProps
    const [listItems, setListItems] = useState(list)
    const [moveDetail, setMoveDetail] = useState(initialObj);
    const [loading, setLoading] = useState(true)
    const testRef = useRef<HTMLButtonElement>(null);



    const urlParams = new URLSearchParams(window?.location?.search);
    const custToken: any = urlParams.get('custToken');
    

    if (custToken) {
        sessionStorage.setItem('custToken', custToken?.toString());
    }

    useEffect(() => {
        listItems?.map((item: any) => {
            if (item?.selected === true) {
                let move = {
                    text: item?.text,
                    index: item?.index
                }

                setMoveDetail(move)
            }
        })
    }, [listItems])


    const handleSubmit = async (event: any) => {
        dispatch({
            type: actionTypeConstants.CUSTOMER_JOURNEY,
            payload: {
                "moveDetail": moveDetail
            },
        })
        navigate(btnProps?.nextScreen)
    }

    const dispatch: any = useContextSelector(
        StoreContext,
        (store) => store?.dispatch
    )

    const currentPageContext: any = useContextSelector(
        StoreContext,
        (store) => store?.appState?.currentPageContext
    )

    const customerContext: any = useContextSelector(
        StoreContext,
        (store) => store?.appState?.customerJourneyContext
    )




    useEffect(() => {
        getCustomerDetails();
        clearSessionData()

        //getOnlineBookingDetails()
    }, [])



    const getCustomerDetails = async () => {
        let data = {
            "secureToken": custToken
        }
        let response = await axios.post(`${customerDetailsApiEndPoint}`, data, {
            headers: {
                'x-api-key': api_key,

            }
        })

        if (response) {
            let customerDetails = response?.data
            //`${addrType?.Address1} ,${addrType?.City} ,${addrType?.State} ${addrType?.Zip} ,${addrType?.Country}`
            let fromAddress = customerDetails[0]['fromAddress'][0];
            let toAddress = customerDetails[0]['toAddress'][0];
            let addionalAddr = getAdditionalStops(customerDetails[0]['additionalStop']);
            sessionStorage.setItem('CID', customerDetails[0]['CustomerID'])
            sessionStorage.setItem('customerDetails', JSON.stringify(customerDetails[0]))

    

            let junkEnable = customerDetails[0]['junkEnable'];
            let storageEnable = customerDetails[0]['storageEnable']


            let ancilliaryStatus = true;

            if (junkEnable === 0 && storageEnable === 0) {
                ancilliaryStatus = false;
            }
            dispatch({
                type: actionTypeConstants.CUSTOMER_JOURNEY,
                payload: {
                    "customerDetails": customerDetails[0],
                    "addresses": {
                        "fromAddr": createAddress(customerDetails[0]['fromAddress'][0]),
                        "toAddr": createAddress(customerDetails[0]['toAddress'][0]),
                        "additionalAddress": createAdditionalAddr(customerDetails[0]['additionalStop'])
                    },
                    "zipInfo": {
                        "fromAddress": {
                            "city": fromAddress?.City,
                            "state": fromAddress?.State,
                            "zip": fromAddress?.Zip,
                            "country": fromAddress?.Country,
                            "address": fromAddress?.Address1,
                        },
                        "toAddress": {
                            "city": toAddress?.City,
                            "state": toAddress?.State,
                            "zip": toAddress?.Zip,
                            "country": toAddress?.Country,
                            "address": toAddress?.Address1,
                        },
                        ...addionalAddr

                    },
                    "callPhone": customerDetails[0]['BranchNo'],

                },
            })

            sessionStorage.setItem('phone', customerDetails[0]['BranchNo'])

            setLoading(false)
        }



    }

    const handleListClick = (event: any, index: any) => {

        let listArr = [...listItems]

        listArr.forEach((element: any) => {
            if (element?.index === index) {
                element['selected'] = true
                dispatch({
                    type: actionTypeConstants.CUSTOMER_JOURNEY,
                    payload: {
                        "moveDetail": {
                            text: element?.text,
                            index: index
                        }
                    },
                })

            } else {
                element['selected'] = false
            }
        });
        setListItems([...listArr])



    }


    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                p={4}
                mt={18}
            >
                {<AmsLoading />}
            </Box>
        )
    }



    return (
        <Box className="baseContainerBlock HomeBlock">
            <Box className="mainContainer">
                <Box className="title">
                    <AmsTypography variant="h1" text={title} />
                </Box>
                <Box className="list">
                    {listItems.map((item: any, index: any) => {
                        return (
                            <SelectedListItem key={index} selected={item?.selected} index={item?.index} text={item?.text} handleListClick={handleListClick} />
                        )
                    })}
                </Box>

            </Box>
            <Box className="buttonContainerBlock" >

                <Box className="homeButtonContainer" id="buttonId">
                    <AmsButton
                        attributes={btnProps?.attributes}
                        handleClick={handleSubmit}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default Home